import { render, staticRenderFns } from "./plogdialog.vue?vue&type=template&id=52d4fc04&scoped=true&"
import script from "./plogdialog.vue?vue&type=script&lang=js&"
export * from "./plogdialog.vue?vue&type=script&lang=js&"
import style0 from "./plogdialog.vue?vue&type=style&index=0&id=52d4fc04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d4fc04",
  null
  
)

export default component.exports